import { Component, Input } from '@angular/core';
import { InrPatientProfile } from "../../../../shared/models/inr-patient-profile.model";
import { Subject, takeUntil } from "rxjs";
import { INRService } from "../../../../shared/services/inr.service";
import { ConfirmationService, ConfirmEventType, MessageService } from "primeng/api";

@Component({
  selector: 'app-inr-patient-profile-card',
  templateUrl: './inr-patient-profile-component-card.component.html',
  styleUrls: ['./inr-patient-profile-component-card.component.css']
})
export class InrPatientProfileComponentCard {
  @Input() patientDate!: InrPatientProfile;
  destroy$: Subject<any> = new Subject<any>();
  statusLis: { value: string; label: string; }[] = [
    {
      value: "PENDING",
      label: "Pending"
    },
    {
      value: "REVIWED",
      label: "Reviewed"
    }
  ];

  constructor(private readonly inrService: INRService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService) {
  }

  calculateAge(birthDate: string): string {
    if (!birthDate) return '';
    const today = new Date();
    const dob = new Date(birthDate);
    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    if (months < 0 || (months === 0 && today.getDate() < dob.getDate())) {
      years--;
      months += 12;
    }
    return `${years} Y ${months} M`;
  }



  setNewStatus() {
    // this.inrService.updateInrStatus(this.patientDate).pipe(takeUntil(this.destroy$)).subscribe((inr) => {
    //   this.patientDate.inr = inr;
    this.messageService.add({
      severity: 'success', summary: 'Confirmed',
      detail: 'The status is updated '
    });
    // });
  }

  onChangeStatus() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to change the status?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.setNewStatus();
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      }
    });
  }
}
